var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 14 14",
    role: "img",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 127.4696,
    x2: 127.4696,
    y1: 82.259239,
    y2: 173.66644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#86BBE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1072BA"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ef3f36",
    d: "M6.98477663 1.00106312s3.52400739-.15814053 5.39235825 3.38402026H6.68491785S5.61068512 4.3504609 4.69304895 5.6536699c-.26359875.54698845-.54694167 1.11044598-.22897627 2.22089196-.4580461-.7760115-2.4317616-4.21271409-2.4317616-4.21271409s1.39215135-2.52075074 4.95241877-2.66078465z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcd900",
    d: "M12.19424395 9.9932707S10.56811011 13.12520187 6.56795 12.97033643c.49425935-.85508177 2.8469039-4.9293995 2.8469039-4.9293995s.56841696-.91272352-.10213633-2.35924153c-.34107825-.50249388-.6887067-1.02805382-1.80897798-1.30816843.9012139-.00818775 4.8635232 0 4.8635232 0s1.4843688 2.46638408-.17301884 5.61974375z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#61bc5b",
    d: "M1.80001293 10.01797431s-1.89960467-2.97379061.23557325-6.36108598c.4926218.85508178 2.84526634 4.9293995 2.84526634 4.9293995s.50745332.94898356 2.09400524 1.09060823c.604677-.04444778 1.23401082-.08234536 2.03804782-.91103919-.44326137.78424604-2.43185518 4.21107654-2.43185518 4.21107654s-2.87984204.0527291-4.78108426-2.9589591z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#5ab055",
    d: "M6.56631245 12.99999947l.80066833-3.34116324s.87978538-.06924497 1.6178993-.87814783c-.4580461.80567455-2.41856763 4.21931107-2.41856763 4.21931107z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M4.30261026 7.03758671c0-1.47285917 1.19447568-2.66733485 2.66733485-2.66733485S9.63727996 5.56472754 9.63727996 7.0375867c0 1.47290595-1.19447568 2.66733485-2.66733485 2.66733485C5.49708594 9.703284 4.30261026 8.51049265 4.30261026 7.0375867z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M80.004 129.056c0-26.198 21.234-47.467 47.468-47.467 26.198 0 47.467 21.234 47.467 47.467 0 26.199-21.233 47.468-47.467 47.468-26.199 0-47.468-21.269-47.468-47.468z",
    transform: "translate(1.0058948 .99942557) scale(.04679)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaca05",
    d: "M12.36557846 4.3752113L9.068863 5.34230148s-.49753445-.72987938-1.56676096-.96709018c.92755505-.00495944 4.86347642 0 4.86347642 0z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#df3a32",
    d: "M4.39983394 7.75263457c-.46300554-.80235266-2.36752286-4.0907868-2.36752286-4.0907868l2.44163369 2.41524574s-.25045157.51568786-.15650299 1.253755l.08234537.42178606z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.ea5a9d28ece9f5d81368fd6e7b346fb1.svg";
export { ForwardRef as ReactComponent };